import { BreadCrumbs } from "../../shared/breadCrumbs/BreadCrumbs";
import { TopBar } from "../../shared/topBar/TopBar";
import { AgGridReact } from 'ag-grid-react';
import { UrlPath } from "../../../config/routeConfig";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import { getEmailRules } from '../../actions/emailRulesAction';
import { EmailRulesGridContainer } from "./EmailRulesList";
import { sbaAxios } from "../../utils/sbaAxios";
import { getUserPageAccess } from "../../../config/apiConfig";
import { LoadingScreen } from "../../UiComponents/LoadingComponent";
import { ToastContainer } from "react-toastify";
// import { getPageLevelAccess } from "../../api/authorization";


export const EmailRulesList = () => {
  
  const entities=localStorage.getItem("Entities");
  const localAssetId =(JSON.parse(entities)).AssetId;
  
  const locationData = useLocation();
  const dispatch = useDispatch();

  const previouslyActiveTab = locationData.state === null ? 1 : locationData.state;
  
  const [valueToPass, setValueToPass] = useState(previouslyActiveTab);

  const [ClientEmailRuleAccess, setClientEmailRuleAccess] = useState(false);
  const [InvestmentEmailRuleAcess,setInvestmentEmailRuleAcess] = useState(false);
  const [DeletionEmailRuleAccess, setDeletionEmailRuleAccess] = useState(false);
  const [loader, setLoader] = useState(true);

  const [render, setRender] = useState(false);
  
  useEffect(() => {
    document.title = "Email Rules"
    dispatch(getEmailRules(previouslyActiveTab, null, true));
    getEmailRuleAccess();
  }, [render]);



  const getEmailRuleAccess = async () => {
    try {
      const clientEmailRuleAccessPromise = sbaAxios({ url: `${getUserPageAccess}?keyName=ClientEmailRuleAccess` });
      const deletionEmailRuleAccessPromise = sbaAxios({ url: `${getUserPageAccess}?keyName=DeletionEmailRuleAccess` });
      const investmentEmailRuleAccessPromise = sbaAxios({ url: `${getUserPageAccess}?keyName=InvEmailRuleAccess` });
      const [
        clientEmailRuleAccessResponse,
        deletionEmailRuleAccessResponse,
        investmentEmailRuleAccessResponse
      ] = await Promise.all([
        clientEmailRuleAccessPromise,
        deletionEmailRuleAccessPromise,
        investmentEmailRuleAccessPromise
      ]);

      setClientEmailRuleAccess(clientEmailRuleAccessResponse);
      setDeletionEmailRuleAccess(deletionEmailRuleAccessResponse);
      setInvestmentEmailRuleAcess(investmentEmailRuleAccessResponse);
      setLoader(false);
    } catch (error) {
      console.error("An error occurred:", error);
      setLoader(false);
    }
  };

  const handleTabSelect = (tabKey) => {
    dispatch(getEmailRules(tabKey, null, true));
    setValueToPass(tabKey);
  };
  const Level = [{ BreadCrumb: "Email Rules", Routes: `${UrlPath.EmailRulesList}${localAssetId}` }]

  return (
    <>
      <TopBar label={"Email Rules"} />
      <div id="content" class="asset-detail-screen mainContentData">
        <BreadCrumbs Levels={Level} />
        <div class="p-4">
          {loader ?  <><LoadingScreen/></>:  <Tabs
            defaultActiveKey={previouslyActiveTab}
            id="uncontrolled-tab-example"
            className="ms-3"
            onSelect={handleTabSelect}
          >
            <Tab
              eventKey={1}
              title="Investment Email Rules"
              disabled={!InvestmentEmailRuleAcess}
            >
              <div key="1-content">
                <div class="p-3 bg-white life-science rounded">
                  <div className="row m-0" style={{ margintop: "-5px" }}>
                    <div class="col-lg-12 px-0">
                      {!InvestmentEmailRuleAcess ? (
                        <> Unauthorized Access </>
                      ) : (
                        <>
                          <EmailRulesGridContainer
                            ActiveTab={valueToPass}
                            setRender={setRender}
                            render={render}
                          />
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </Tab>
            <Tab
              eventKey={2}
              title="Client Email Rules"
              disabled={!ClientEmailRuleAccess}
            >
              <div className="p-3 bg-white life-science rounded">
                {!ClientEmailRuleAccess ? (
                  <> Unauthorized Access </>
                ) : (
                  <>
                    <EmailRulesGridContainer
                      ActiveTab={valueToPass}
                      setRender={setRender}
                      render={render}
                    />
                  </>
                )}
              </div>
            </Tab>
            <Tab
              eventKey={3}
              title="Deletion Email Rules"
              disabled={!DeletionEmailRuleAccess}
            >
              <div className="p-3 bg-white life-science rounded">
                {!DeletionEmailRuleAccess ? (
                  <> Unauthorized Access </>
                ) : (
                  <>
                    <EmailRulesGridContainer
                      ActiveTab={valueToPass}
                      setRender={setRender}
                      render={render}
                    />
                  </>
                )}
              </div>
            </Tab>
          </Tabs> }
        
        </div>
      </div>
      <ToastContainer/>
    </>
  );
}